import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { api_gateway } from '../../conexoes/api'
import iconeModalNovidades from '../../icones/iconesVersaoClara/novidades-modal-icone.svg'
import { elipseVerde, fecharJanela } from '../../utils/alternanciaIcones'
import '../../css/releaseNotes/releaseNotes.css'
import SpinerVeye from '../spinnerVeye/spinnerVeye.js'

const idConteudoDivStr = 'lista-novidades-versao'
const emailSuporte = 'veye@veye.com.br'

let conteudoStrHTML

export default function ModalDetalhesVersao(props) {
  const [data, setData] = useState('')
  const [versao, setVersao] = useState('')
  const [imagemBase64, setImagemBase64] = useState(false)

  const [spinAtivo, setSpinAtivo] = useState(true)
  const modal = useRef()

  function handleCancelar() {
    props.setRevelarMenuReleaseNotes(false)
  }

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  useEffect(() => {
    async function carregarDados() {
      conteudoStrHTML = ''
      let rotaGetVersao = 'm1/consultar/versionamento'

      if (props.cd_pav_release) {
        // Detalhes da versão
        rotaGetVersao += '?cd_pav_release=' + props.cd_pav_release
      }

      await api_gateway
        .get(rotaGetVersao)
        .then(async (res) => {
          if (res?.status === 200) {
            const dados = res?.data?.dados[0]
            setVersao(dados.ds_release)
            setData(moment(dados.dt_created_at).format('DD/MM/YYYY'))
            setImagemBase64(dados.bl_imagem)
            conteudoStrHTML = dados.ds_texto

            if (!props.cd_pav_release) {
              // novidades
              let jaExiste = false
              const { lastReleaseNoteRead } = JSON.parse(
                localStorage.getItem('releaseNotes')
              )
              if (lastReleaseNoteRead > 0) {
                jaExiste = true
              }
              const lastReleaseNotes = dados.cd_pav_release

              if (
                lastReleaseNotes > lastReleaseNoteRead ||
                !lastReleaseNoteRead
              ) {
                api_gateway.post('m1/alterar/usuario_versionamento', {
                  cd_pav_release: lastReleaseNotes,
                  jaExiste
                })
                localStorage.setItem(
                  'releaseNotes',
                  JSON.stringify({
                    lastReleaseNotes,
                    lastReleaseNoteRead: lastReleaseNotes
                  })
                )
              }
            }
            // setVersao('V1.1.1.1'); // exemplo
            // setData('20/06/2023');
            // conteudoStrHTML = '<div><strong>Teste Conteúdo</strong></div>';
          }
        })
        .catch((err) => {
          console.error({ err })
          conteudoStrHTML = 'Erro ao consultar dados!'
        })

      setSpinAtivo(false)
      let conteudoDiv = document.getElementById(idConteudoDivStr)
      conteudoDiv.innerHTML = conteudoStrHTML
    }

    carregarDados()

    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) 


  return (
    <Form ref={modal} className="modal-acao-novidades fundo-cor-6">
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <div className="tela-painel-novidades">
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">
                {props.cd_pav_release ? 'Detalhes da Versão' : 'Novidades'}
              </div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>

        <Form.Row>
          <Col>
            <span className="fonte-cor-1">
              {data} - {versao}
            </span>
          </Col>
        </Form.Row>

        <div className="div-corpo-novidades">
          {(conteudoStrHTML?.indexOf('<img') === -1 || imagemBase64) && ( // se não tem imagem no corpo html vindo do banco OU tem imagem no campo 'bl_imagem'
            <Form.Row>
              <Col id="div-imagem-novidades">
                {data && (
                  <img
                    id="imagem-modal-novidades"
                    src={imagemBase64 || iconeModalNovidades}
                    alt="Novidades da versão"
                  />
                )}
              </Col>
            </Form.Row>
          )}

          <Form.Row id={idConteudoDivStr} className="fonte-cor-1">
            <span>carregando...</span>
          </Form.Row>
        </div>

        <Form.Row id="novidades-rodape">
          <Col>
            <a href={`mailto:${emailSuporte}`}>{emailSuporte}</a>
            {!props.cd_pav_release && (
              <>
                <div id="risco-divisorio" />
                <Link to="/veye/tabela/versoes">
                  <button onClick={handleCancelar}>HISTÓRICO DE VERSÕES</button>
                </Link>
              </>
            )}
          </Col>
        </Form.Row>
      </div>
    </Form>
  )
}
